import clsx from 'clsx';
import React, { useEffect, useRef, useState } from 'react';

const CartContent = ({
  children,
  showScrollbarOnHover,
}: {
  children: React.ReactNode;
  showScrollbarOnHover: boolean;
}) => {
  const [isScrollable, setIsScrollable] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const checkScrollable = () => {
      if (containerRef.current) {
        const { scrollHeight, clientHeight } = containerRef.current;
        setIsScrollable(scrollHeight > clientHeight);
      }
    };

    checkScrollable();

    if (containerRef.current) {
      containerRef.current.addEventListener('scroll', checkScrollable);
    }

    return () => {
      if (containerRef.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        containerRef.current.removeEventListener('scroll', checkScrollable);
      }
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className={clsx(
        'flex flex-grow flex-col',
        'vertical-scrollbar overflow-y-auto overflow-x-hidden !scrollbar-track-transparent scrollbar-thumb-stroke-base-subdued',
        showScrollbarOnHover && isScrollable && 'hover-scrollbar-track',
      )}
    >
      {children}
    </div>
  );
};

export default CartContent;
